import { Button } from "@material-ui/core";
import React from "react";
import { useDispatch } from "react-redux";
import { demoLogin } from "../../features/userSlice";
import { auth, provider } from "../../firebase";
import "./Login.css";

function Login() {
  const dispatch = useDispatch();

  const signIn = () => {
    auth.signInWithPopup(provider).catch((error) => console.log(error));
  };

  const demoSignIn = () => {
    dispatch(
      demoLogin({
        uid: "1234",
        photo: null,
        email: "demo@email.com",
        displayName: "Demo User",
        demo: true,
      })
    );
  };

  return (
    <div className="login">
      <div className="login__logo">
        <img
          src="https://1000logos.net/wp-content/uploads/2020/10/Discord-logo.png"
          alt="discord_logo"
        />
      </div>
      <div className="login__buttons">
        <Button onClick={demoSignIn}>Demo Sign In</Button>
        <Button onClick={signIn}>Sign In</Button>
      </div>
    </div>
  );
}

export default Login;
